module.exports = __webpack_public_path__ + "static/media/logo_msb.c706e1da.svg";